module.exports = __webpack_public_path__ + "aada7f6a22a1b50b3cbb3d70b50b70bd.png";